import Brain from '../../classes/brain';
import Utils from '../../classes/utils';

export default class BrainTextTransition extends Brain {

	constructor(args) {
		super(args);

		this.speed = 0.001;
		this.duration = args ? args.duration || 2000 : 2000;
		
		this.active = true;
		this.progress = -1;
		this.increment = 0;
		this.phase = 'start';
		this.maxAlpha = 0.9;
	}

	init(entity) {
		super.init(entity);
		this.entity.sprite.alpha = 0;
	}

	update(delta, deltaNormal) {

		if(this.active) {
			this.progress += this.increment*delta;
			let s = this.entity.sprite;
			let v = Utils.clamp(this.progress, 0, 1)
			switch(this.phase) {
				case 'in' : 
				case 'out' : 
					s.slop = v * 0.2;
					s.wobble = Math.pow(v, 2) * 4;
					s.alpha = this.maxAlpha-(v*this.maxAlpha);
					break;
			}
			if(this.progress < 0 || this.progress > 1) {
				// next phase
				switch(this.phase) {
					case 'start' :
						this.phase = 'in';
						this.increment = -this.speed;
						this.progress = 1;
						break;
					case 'in' :
						this.phase = 'wait';
						this.increment = 1/this.duration;
						this.progress = 0;
						break;
					case 'wait' :
						this.phase = 'out';
						this.increment = this.speed;
						this.progress = 0;
						break;
					case 'out':
						this.phase = 'start';
						break;
				}
			}
		}

	}

}